export type AppLocale = 'zh-CN' | 'zh-TW' | 'en-US' | 'ko-KR' | 'ja-JP' | 'fr-FR' | 'es-ES';

export const DEFAULT_APP_LOCALE: AppLocale = 'zh-CN';
export const APP_LOCALE_STORAGE_KEY = 'd-sense:locale';

export interface I18nContextValue {
    locale: AppLocale;
    setLocale: (locale: AppLocale) => void;
    t: (key: string) => string;
}
